import * as a from "react";
import { ViewportSizes as d } from "../../utils/viewport.es.js";
function c(n = `(min-width: ${d.md.minWidth}px)`) {
  const i = (e) => typeof window < "u" ? window.matchMedia(e).matches : !1, [s, r] = a.useState(i(n));
  function t() {
    r(i(n));
  }
  return a.useEffect(() => {
    const e = window.matchMedia(n);
    return t(), e.addListener ? e.addListener(t) : e.addEventListener("change", t), () => {
      e.removeListener ? e.removeListener(t) : e.removeEventListener("change", t);
    };
  }, [n]), s;
}
export {
  c as default
};
//# sourceMappingURL=useMediaQuery.es.js.map
